import { render } from "./VisaLogo.vue?vue&type=template&id=377ef98d&scoped=true"
const script = {}

import "./VisaLogo.vue?vue&type=style&index=0&id=377ef98d&scoped=true&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377ef98d"]])

export default __exports__